var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-app-prompt"},[_vm._v("\n    Manage Your subscription in Fusebox 2.0\n")])}
var staticRenderFns = []

export { render, staticRenderFns }